import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import { NgStyleInterface } from "ng-zorro-antd/core/types";

@Component({
  selector: "v4-widget-selected-panel",
  templateUrl: "./selected-panel.component.html",
  styleUrls: ["./selected-panel.component.scss"]
})
export class SelectedPanelComponent implements OnInit, AfterViewInit {
  @Input() selectedCount;
  @Input() bottom = 0;
  @ViewChild("fixedEl", { static: true }) private fixedEl: ElementRef<HTMLDivElement>;
  constructor(private ele: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.updateAffixPosition();
  }

  private updateAffixPosition() {
    const parentEle = this.ele.nativeElement?.parentElement;
    const rect = parentEle?.getBoundingClientRect();

    this.setAffixStyle(this.fixedEl.nativeElement, {
      position: "fixed",
      left: rect?.left,
      width: rect?.width,
      bottom: this.bottom
    });
  }

  private setAffixStyle(el: any, style: NgStyleInterface) {
    this.renderer.setStyle(el, "cssText", this.getStyleAsText(style));
  }

  private getStyleAsText(cssObj): string {
    return Object.keys(cssObj)
      .map(key => `${key}: ${cssObj[key]}`)
      .join(";");
  }
}
